import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../Unit.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../ranges/_Ranges.mjs';
import { Companion_instance1a0yry1hi33tg as Companion_instance } from './AbstractList.mjs';
import {
  arrayCopytctsywo3h7gj as arrayCopy,
  arrayOfNulls3cqbl98qmfq5b as arrayOfNulls,
  terminateCollectionToArray12671uhv05xea as terminateCollectionToArray,
} from './collectionJs.mjs';
import { get_lastIndexx0qsydpfv3mu as get_lastIndex } from './_Arrays.mjs';
import { fill3hcjvebk42tyx as fill } from './_ArraysJs.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { AbstractMutableList192xfq8ycgofs as AbstractMutableList } from './AbstractMutableListJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex_0 } from './CollectionsKt.mjs';
import { equals2au1ep9vhcato as equals } from '../js/coreRuntime.mjs';
import { isArray1hxjqtqy632bc as isArray } from '../js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ensureCapacity($this, minCapacity) {
  if (minCapacity < 0)
    throw IllegalStateException().o('Deque is too big.');
  if (minCapacity <= $this.qj_1.length)
    return Unit_instance;
  if ($this.qj_1 === Companion_getInstance().sj_1) {
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = coerceAtLeast(minCapacity, 10);
    tmp.qj_1 = Array(size);
    return Unit_instance;
  }
  var newCapacity = Companion_instance.xa($this.qj_1.length, minCapacity);
  copyElements($this, newCapacity);
}
function copyElements($this, newCapacity) {
  // Inline function 'kotlin.arrayOfNulls' call
  var newElements = Array(newCapacity);
  var tmp0 = $this.qj_1;
  var tmp6 = $this.pj_1;
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex = $this.qj_1.length;
  arrayCopy(tmp0, newElements, 0, tmp6, endIndex);
  var tmp0_0 = $this.qj_1;
  var tmp4 = $this.qj_1.length - $this.pj_1 | 0;
  // Inline function 'kotlin.collections.copyInto' call
  var endIndex_0 = $this.pj_1;
  arrayCopy(tmp0_0, newElements, tmp4, 0, endIndex_0);
  $this.pj_1 = 0;
  $this.qj_1 = newElements;
}
function positiveMod($this, index) {
  return index >= $this.qj_1.length ? index - $this.qj_1.length | 0 : index;
}
function negativeMod($this, index) {
  return index < 0 ? index + $this.qj_1.length | 0 : index;
}
function incremented($this, index) {
  return index === get_lastIndex($this.qj_1) ? 0 : index + 1 | 0;
}
function decremented($this, index) {
  return index === 0 ? get_lastIndex($this.qj_1) : index - 1 | 0;
}
function copyCollectionElements($this, internalIndex, elements) {
  var iterator = elements.u1();
  var inductionVariable = internalIndex;
  var last = $this.qj_1.length;
  if (inductionVariable < last)
    $l$loop: do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!iterator.v1())
        break $l$loop;
      $this.qj_1[index] = iterator.w1();
    }
     while (inductionVariable < last);
  var inductionVariable_0 = 0;
  var last_0 = $this.pj_1;
  if (inductionVariable_0 < last_0)
    $l$loop_0: do {
      var index_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      if (!iterator.v1())
        break $l$loop_0;
      $this.qj_1[index_0] = iterator.w1();
    }
     while (inductionVariable_0 < last_0);
  $this.rj_1 = $this.rj_1 + elements.v2() | 0;
}
function removeRangeShiftPreceding($this, fromIndex, toIndex) {
  // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
  var index = fromIndex - 1 | 0;
  var copyFromIndex = positiveMod($this, $this.pj_1 + index | 0);
  // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
  var index_0 = toIndex - 1 | 0;
  var copyToIndex = positiveMod($this, $this.pj_1 + index_0 | 0);
  var copyCount = fromIndex;
  while (copyCount > 0) {
    var tmp0 = copyCount;
    var tmp2 = copyFromIndex + 1 | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var c = copyToIndex + 1 | 0;
    var segmentLength = Math.min(tmp0, tmp2, c);
    var tmp0_0 = $this.qj_1;
    var tmp2_0 = $this.qj_1;
    var tmp4 = (copyToIndex - segmentLength | 0) + 1 | 0;
    var tmp6 = (copyFromIndex - segmentLength | 0) + 1 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = copyFromIndex + 1 | 0;
    arrayCopy(tmp0_0, tmp2_0, tmp4, tmp6, endIndex);
    copyFromIndex = negativeMod($this, copyFromIndex - segmentLength | 0);
    copyToIndex = negativeMod($this, copyToIndex - segmentLength | 0);
    copyCount = copyCount - segmentLength | 0;
  }
}
function removeRangeShiftSucceeding($this, fromIndex, toIndex) {
  // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
  var copyFromIndex = positiveMod($this, $this.pj_1 + toIndex | 0);
  // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
  var copyToIndex = positiveMod($this, $this.pj_1 + fromIndex | 0);
  var copyCount = $this.rj_1 - toIndex | 0;
  while (copyCount > 0) {
    var tmp0 = copyCount;
    var tmp2 = $this.qj_1.length - copyFromIndex | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var c = $this.qj_1.length - copyToIndex | 0;
    var segmentLength = Math.min(tmp0, tmp2, c);
    var tmp0_0 = $this.qj_1;
    var tmp2_0 = $this.qj_1;
    var tmp4 = copyToIndex;
    var tmp6 = copyFromIndex;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = copyFromIndex + segmentLength | 0;
    arrayCopy(tmp0_0, tmp2_0, tmp4, tmp6, endIndex);
    copyFromIndex = positiveMod($this, copyFromIndex + segmentLength | 0);
    copyToIndex = positiveMod($this, copyToIndex + segmentLength | 0);
    copyCount = copyCount - segmentLength | 0;
  }
}
function nullifyNonEmpty($this, internalFromIndex, internalToIndex) {
  if (internalFromIndex < internalToIndex) {
    fill($this.qj_1, null, internalFromIndex, internalToIndex);
  } else {
    fill($this.qj_1, null, internalFromIndex, $this.qj_1.length);
    fill($this.qj_1, null, 0, internalToIndex);
  }
}
function registerModification($this) {
  $this.z6_1 = $this.z6_1 + 1 | 0;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        // Inline function 'kotlin.emptyArray' call
        tmp.sj_1 = [];
        this.tj_1 = 10;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
function init_kotlin_collections_ArrayDeque(_this__u8e3s4) {
  Companion_getInstance();
  _this__u8e3s4.pj_1 = 0;
  _this__u8e3s4.rj_1 = 0;
}
var ArrayDequeClass;
function ArrayDeque() {
  if (ArrayDequeClass === VOID) {
    class $ extends AbstractMutableList() {
      v2() {
        return this.rj_1;
      }
      static uj() {
        Companion_getInstance();
        var $this = this.m7();
        init_kotlin_collections_ArrayDeque($this);
        $this.qj_1 = Companion_getInstance().sj_1;
        return $this;
      }
      s1() {
        return this.rj_1 === 0;
      }
      vj(element) {
        registerModification(this);
        ensureCapacity(this, this.rj_1 + 1 | 0);
        this.pj_1 = decremented(this, this.pj_1);
        this.qj_1[this.pj_1] = element;
        this.rj_1 = this.rj_1 + 1 | 0;
      }
      wj(element) {
        registerModification(this);
        ensureCapacity(this, this.rj_1 + 1 | 0);
        var tmp = this.qj_1;
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = this.rj_1;
        tmp[positiveMod(this, this.pj_1 + index | 0)] = element;
        this.rj_1 = this.rj_1 + 1 | 0;
      }
      xj() {
        if (this.s1())
          throw NoSuchElementException().f2('ArrayDeque is empty.');
        registerModification(this);
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var internalIndex = this.pj_1;
        var tmp = this.qj_1[internalIndex];
        var element = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
        this.qj_1[this.pj_1] = null;
        this.pj_1 = incremented(this, this.pj_1);
        this.rj_1 = this.rj_1 - 1 | 0;
        return element;
      }
      yj() {
        return this.s1() ? null : this.xj();
      }
      zj() {
        if (this.s1())
          throw NoSuchElementException().f2('ArrayDeque is empty.');
        registerModification(this);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = get_lastIndex_0(this);
        var internalLastIndex = positiveMod(this, this.pj_1 + index | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var tmp = this.qj_1[internalLastIndex];
        var element = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
        this.qj_1[internalLastIndex] = null;
        this.rj_1 = this.rj_1 - 1 | 0;
        return element;
      }
      n2(element) {
        this.wj(element);
        return true;
      }
      g5(index, element) {
        Companion_instance.e7(index, this.rj_1);
        if (index === this.rj_1) {
          this.wj(element);
          return Unit_instance;
        } else if (index === 0) {
          this.vj(element);
          return Unit_instance;
        }
        registerModification(this);
        ensureCapacity(this, this.rj_1 + 1 | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var internalIndex = positiveMod(this, this.pj_1 + index | 0);
        if (index < (this.rj_1 + 1 | 0) >> 1) {
          var decrementedInternalIndex = decremented(this, internalIndex);
          var decrementedHead = decremented(this, this.pj_1);
          if (decrementedInternalIndex >= this.pj_1) {
            this.qj_1[decrementedHead] = this.qj_1[this.pj_1];
            var tmp0 = this.qj_1;
            var tmp2 = this.qj_1;
            var tmp4 = this.pj_1;
            var tmp6 = this.pj_1 + 1 | 0;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex = decrementedInternalIndex + 1 | 0;
            arrayCopy(tmp0, tmp2, tmp4, tmp6, endIndex);
          } else {
            var tmp0_0 = this.qj_1;
            var tmp2_0 = this.qj_1;
            var tmp4_0 = this.pj_1 - 1 | 0;
            var tmp6_0 = this.pj_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_0 = this.qj_1.length;
            arrayCopy(tmp0_0, tmp2_0, tmp4_0, tmp6_0, endIndex_0);
            this.qj_1[this.qj_1.length - 1 | 0] = this.qj_1[0];
            var tmp0_1 = this.qj_1;
            var tmp2_1 = this.qj_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_1 = decrementedInternalIndex + 1 | 0;
            arrayCopy(tmp0_1, tmp2_1, 0, 1, endIndex_1);
          }
          this.qj_1[decrementedInternalIndex] = element;
          this.pj_1 = decrementedHead;
        } else {
          // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
          var index_0 = this.rj_1;
          var tail = positiveMod(this, this.pj_1 + index_0 | 0);
          if (internalIndex < tail) {
            var tmp0_2 = this.qj_1;
            var tmp2_2 = this.qj_1;
            // Inline function 'kotlin.collections.copyInto' call
            var destinationOffset = internalIndex + 1 | 0;
            arrayCopy(tmp0_2, tmp2_2, destinationOffset, internalIndex, tail);
          } else {
            var tmp0_3 = this.qj_1;
            // Inline function 'kotlin.collections.copyInto' call
            var destination = this.qj_1;
            arrayCopy(tmp0_3, destination, 1, 0, tail);
            this.qj_1[0] = this.qj_1[this.qj_1.length - 1 | 0];
            var tmp0_4 = this.qj_1;
            var tmp2_3 = this.qj_1;
            var tmp4_1 = internalIndex + 1 | 0;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_2 = this.qj_1.length - 1 | 0;
            arrayCopy(tmp0_4, tmp2_3, tmp4_1, internalIndex, endIndex_2);
          }
          this.qj_1[internalIndex] = element;
        }
        this.rj_1 = this.rj_1 + 1 | 0;
      }
      z2(elements) {
        if (elements.s1())
          return false;
        registerModification(this);
        ensureCapacity(this, this.rj_1 + elements.v2() | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = this.rj_1;
        var tmp$ret$0 = positiveMod(this, this.pj_1 + index | 0);
        copyCollectionElements(this, tmp$ret$0, elements);
        return true;
      }
      w2(index) {
        Companion_instance.n7(index, this.rj_1);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var internalIndex = positiveMod(this, this.pj_1 + index | 0);
        var tmp = this.qj_1[internalIndex];
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      }
      o3(index, element) {
        Companion_instance.n7(index, this.rj_1);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var internalIndex = positiveMod(this, this.pj_1 + index | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var tmp = this.qj_1[internalIndex];
        var oldElement = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
        this.qj_1[internalIndex] = element;
        return oldElement;
      }
      y2(element) {
        return !(this.w4(element) === -1);
      }
      w4(element) {
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = this.rj_1;
        var tail = positiveMod(this, this.pj_1 + index | 0);
        if (this.pj_1 < tail) {
          var inductionVariable = this.pj_1;
          if (inductionVariable < tail)
            do {
              var index_0 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              if (equals(element, this.qj_1[index_0]))
                return index_0 - this.pj_1 | 0;
            }
             while (inductionVariable < tail);
        } else {
          var tmp;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!this.s1()) {
            tmp = this.pj_1 >= tail;
          } else {
            tmp = false;
          }
          if (tmp) {
            var inductionVariable_0 = this.pj_1;
            var last = this.qj_1.length;
            if (inductionVariable_0 < last)
              do {
                var index_1 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                if (equals(element, this.qj_1[index_1]))
                  return index_1 - this.pj_1 | 0;
              }
               while (inductionVariable_0 < last);
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < tail)
              do {
                var index_2 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                if (equals(element, this.qj_1[index_2]))
                  return (index_2 + this.qj_1.length | 0) - this.pj_1 | 0;
              }
               while (inductionVariable_1 < tail);
          }
        }
        return -1;
      }
      h5(index) {
        Companion_instance.n7(index, this.rj_1);
        if (index === get_lastIndex_0(this)) {
          return this.zj();
        } else if (index === 0) {
          return this.xj();
        }
        registerModification(this);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var internalIndex = positiveMod(this, this.pj_1 + index | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var tmp = this.qj_1[internalIndex];
        var element = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
        if (index < this.rj_1 >> 1) {
          if (internalIndex >= this.pj_1) {
            var tmp0 = this.qj_1;
            var tmp2 = this.qj_1;
            var tmp4 = this.pj_1 + 1 | 0;
            // Inline function 'kotlin.collections.copyInto' call
            var startIndex = this.pj_1;
            arrayCopy(tmp0, tmp2, tmp4, startIndex, internalIndex);
          } else {
            var tmp0_0 = this.qj_1;
            // Inline function 'kotlin.collections.copyInto' call
            var destination = this.qj_1;
            arrayCopy(tmp0_0, destination, 1, 0, internalIndex);
            this.qj_1[0] = this.qj_1[this.qj_1.length - 1 | 0];
            var tmp0_1 = this.qj_1;
            var tmp2_0 = this.qj_1;
            var tmp4_0 = this.pj_1 + 1 | 0;
            var tmp6 = this.pj_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex = this.qj_1.length - 1 | 0;
            arrayCopy(tmp0_1, tmp2_0, tmp4_0, tmp6, endIndex);
          }
          this.qj_1[this.pj_1] = null;
          this.pj_1 = incremented(this, this.pj_1);
        } else {
          // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
          var index_0 = get_lastIndex_0(this);
          var internalLastIndex = positiveMod(this, this.pj_1 + index_0 | 0);
          if (internalIndex <= internalLastIndex) {
            var tmp0_2 = this.qj_1;
            var tmp2_1 = this.qj_1;
            var tmp6_0 = internalIndex + 1 | 0;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_0 = internalLastIndex + 1 | 0;
            arrayCopy(tmp0_2, tmp2_1, internalIndex, tmp6_0, endIndex_0);
          } else {
            var tmp0_3 = this.qj_1;
            var tmp2_2 = this.qj_1;
            var tmp6_1 = internalIndex + 1 | 0;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_1 = this.qj_1.length;
            arrayCopy(tmp0_3, tmp2_2, internalIndex, tmp6_1, endIndex_1);
            this.qj_1[this.qj_1.length - 1 | 0] = this.qj_1[0];
            var tmp0_4 = this.qj_1;
            var tmp2_3 = this.qj_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_2 = internalLastIndex + 1 | 0;
            arrayCopy(tmp0_4, tmp2_3, 0, 1, endIndex_2);
          }
          this.qj_1[internalLastIndex] = null;
        }
        this.rj_1 = this.rj_1 - 1 | 0;
        return element;
      }
      f5() {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.s1()) {
          registerModification(this);
          // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
          var index = this.rj_1;
          var tail = positiveMod(this, this.pj_1 + index | 0);
          nullifyNonEmpty(this, this.pj_1, tail);
        }
        this.pj_1 = 0;
        this.rj_1 = 0;
      }
      ak(array) {
        var tmp = array.length >= this.rj_1 ? array : arrayOfNulls(array, this.rj_1);
        var dest = isArray(tmp) ? tmp : THROW_CCE();
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = this.rj_1;
        var tail = positiveMod(this, this.pj_1 + index | 0);
        if (this.pj_1 < tail) {
          var tmp0 = this.qj_1;
          // Inline function 'kotlin.collections.copyInto' call
          var startIndex = this.pj_1;
          arrayCopy(tmp0, dest, 0, startIndex, tail);
        } else {
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!this.s1()) {
            var tmp0_0 = this.qj_1;
            var tmp6 = this.pj_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex = this.qj_1.length;
            arrayCopy(tmp0_0, dest, 0, tmp6, endIndex);
            var tmp0_1 = this.qj_1;
            // Inline function 'kotlin.collections.copyInto' call
            var destinationOffset = this.qj_1.length - this.pj_1 | 0;
            arrayCopy(tmp0_1, dest, destinationOffset, 0, tail);
          }
        }
        var tmp_0 = terminateCollectionToArray(this.rj_1, dest);
        return isArray(tmp_0) ? tmp_0 : THROW_CCE();
      }
      n8() {
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.rj_1;
        var tmp$ret$0 = Array(size);
        return this.ak(tmp$ret$0);
      }
      toArray() {
        return this.n8();
      }
      o7(fromIndex, toIndex) {
        Companion_instance.k6(fromIndex, toIndex, this.rj_1);
        var length = toIndex - fromIndex | 0;
        if (length === 0)
          return Unit_instance;
        else if (length === this.rj_1) {
          this.f5();
          return Unit_instance;
        } else if (length === 1) {
          this.h5(fromIndex);
          return Unit_instance;
        }
        registerModification(this);
        if (fromIndex < (this.rj_1 - toIndex | 0)) {
          removeRangeShiftPreceding(this, fromIndex, toIndex);
          var newHead = positiveMod(this, this.pj_1 + length | 0);
          nullifyNonEmpty(this, this.pj_1, newHead);
          this.pj_1 = newHead;
        } else {
          removeRangeShiftSucceeding(this, fromIndex, toIndex);
          // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
          var index = this.rj_1;
          var tail = positiveMod(this, this.pj_1 + index | 0);
          nullifyNonEmpty(this, negativeMod(this, tail - length | 0), tail);
        }
        this.rj_1 = this.rj_1 - length | 0;
      }
    }
    initMetadataForClass($, 'ArrayDeque', $.uj);
    ArrayDequeClass = $;
  }
  return ArrayDequeClass;
}
//region block: exports
export {
  ArrayDeque as ArrayDeque2dzc9uld4xi7n,
};
//endregion

//# sourceMappingURL=ArrayDeque.mjs.map
